import BlankLayout from '../components/layout/BlankLayout';
import ROUTES from '../constants/Routes';
import AuditSheetContainer from '../pages/audit_sheet/AuditSheetContainer';
import DashboardContainer from '../pages/dashboard/DashboardContainer';
import DashboardContainerV2 from '../pages/dashboard/DashboardContainerV2';
import HelpContainer from '../pages/faq/HelpContainer';
import Notifications from '../pages/notifications/Notifications';
import AccountContainer from '../pages/profile/AccountContainer';

const AppRouter = [
  {
    route: ROUTES.DASHBOARD,
    element: <DashboardContainer />,
  },
  {
    route: ROUTES.DASHBOARD_V2,
    element: <DashboardContainerV2 />,
  },
  {
    route: ROUTES.ACCOUNT,
    element: <AccountContainer />,
  },
  {
    route: ROUTES.AUDIT_SHEET,
    element: <AuditSheetContainer />,
    layout: BlankLayout,
  },
  {
    route: ROUTES.VIEW_BATCH_AUDIT_SHEET,
    element: <AuditSheetContainer view={true} batch={true} />,
    layout: BlankLayout,
  },
  {
    route: ROUTES.BATCH_AUDIT_SHEET,
    element: <AuditSheetContainer batch={true} />,
    layout: BlankLayout,
  },
  {
    route: ROUTES.VIEW_AUDIT_SHEET,
    element: <AuditSheetContainer view={true} />,
    layout: BlankLayout,
  },
  {
    route: ROUTES.NOTIFICATIONS,
    element: <Notifications />,
  },
  {
    route: ROUTES.HELP,
    element: <HelpContainer />,
  },
];

export default AppRouter;
